import React, { useState } from "react";
import {
  Box,
  Card,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Train, LocationCity, TrainOutlined } from "@mui/icons-material";

import StructuralTypes from "./StructuralTypes";
import MasterCoachType from "./MasterCoachType";
import CoachTypeMaster from "./CoachTypeMaster";

const CoachType = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
      
        sx={{
          mb: 2.5,
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <Box>

 <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    <TrainOutlined
      sx={{
        fontSize: 30,
        color: "primary.main",
      }}
    />
          
          <Typography variant="h5" fontWeight={800} color="#0f172a">
            {activeTab === 0
              ? "Structural Coach Types"
              : activeTab === 1
                ? "Basic Coach Types"
                : "Coach Code"}
          </Typography>
</Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Manage{" "}
            {activeTab === 0
              ? "Structural Coach Types"
              : activeTab === 1
                ? "Basic Coach Types"
                : "Coach Code"}{" "}
            Master Data
          </Typography>
        </Box>
      </Box>

      <Card
        elevation={0}
        sx={{
          border: "1px solid #e2e8f0",
          borderRadius: 3,
          overflow: "hidden",
          width: "100%",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(event, value) => setActiveTab(value)}
          variant={isMobile ? "fullWidth" : "standard"}
          sx={{
            borderBottom: "1px solid #e2e8f0",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 700,
              minHeight: 54,
            },
          }}
        >
          <Tab icon={<Train />} iconPosition="start" label="Structural Coach Types" />
          <Tab icon={<TrainOutlined />} iconPosition="start" label="Basic Coach Types" />
          <Tab
            icon={<TrainOutlined />}
            iconPosition="start"
            label="Coach Code"
          />
        </Tabs>

        <Box sx={{ width: "100%" }}>
          {activeTab === 0 && < StructuralTypes/>}
          {activeTab === 1 && <MasterCoachType />}
          {activeTab === 2 && <CoachTypeMaster />}
        </Box>
      </Card>
    </Box>
  );
};

export default CoachType;
